import React, {ReactElement} from 'react';
import {useIntl} from 'react-intl';
import {cx} from '@emotion/css';
import {ReactComponent as LinkedInIcon} from '@fo/shared-images/icons/social/linkedIn.svg';
import DynamicLink from '@fo/components/DynamicLink/DynamicLink';

import styles from './SocialShare.styles';

interface Props {
  urlToShare: string;
}

function LinkedIn({urlToShare}: Props): ReactElement {
  const {formatMessage} = useIntl();

  return (
    <DynamicLink
      className={cx(styles.link, 'unstyledLink')}
      testId="ui.social.LinkedIn"
      href={`https://www.linkedin.com/shareArticle/?mini=true&url=${urlToShare}`}
      blank
    >
      <LinkedInIcon title={formatMessage({id: 'social.share.linkedIn'})} />
    </DynamicLink>
  );
}

export default LinkedIn;
